// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-wUi","content":"styles_content__RHG8I"};